import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";

const B2BSingleInvoiceTable = ({ data }: { data: any }) => {
	return (
		<TableContainer component={Paper} sx={{ mt: 3 }}>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>Service Name</TableCell>
						<TableCell>Description</TableCell>
						<TableCell>Quantity</TableCell>
						<TableCell>Amount</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{data?.map((item) => (
						<TableRow key={item.id}>
							<TableCell>{item.product_name}</TableCell>
							<TableCell>{item.description}</TableCell>
							<TableCell>{item.quantity}</TableCell>
							<TableCell>{item.amount}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default B2BSingleInvoiceTable;
